import { Typography, Grid } from "@mui/material";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerTel2Props {
    customerData: CustomerInterface
}

const CustomerTel2: React.FC<CustomerTel2Props> = ({
    customerData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{ color: "#333399" }}>電話番号（携帯）</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{customerData.ctm_tel2 ? customerData.ctm_tel2 : "未登録"}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerTel2